import { getAwaitSpinAction } from 'automaton/actions/AwaitSpinAction'
import { getAutoState } from 'automaton/states/AutoSpinState'
import { getGambleState } from 'automaton/states/GambleState'
import { getSpinState } from 'automaton/states/SpinState'
import { signal } from 'services/SignalsService'

export function getBetState() {
  const name = 'BET'
  const freeBetModel = game.models.FreebetsModel.get()
  const { rest  } = game.models.GambleModel.get()
  const isGamble = game.models.GambleModel.getIsGamble()

  if (isGamble && !game.models.AutoLimitModel.isAuto && rest !== undefined && rest !== 0 ) {
    if(freeBetModel.isFreeBet  ){
      if(freeBetModel.lastSpinWin > 0){
        signal.dispatch('GAMBLE-FEATURE:SHOW-BUTTON')
      }
    }
    else{
      signal.dispatch('GAMBLE-FEATURE:SHOW-BUTTON')
    }
  }

  if(!freeBetModel.rest && freeBetModel.total > 0){
    signal.dispatch('FREEBET:END')
  }
  signal.dispatch('FREEBET:Enabled', false)

  const actions = [getAwaitSpinAction()]
  const transition = (isAuto) => isAuto
    ? getAutoState()
    : game.models.GambleModel.getStartGamble() ? getGambleState() : getSpinState()

  return {
    name,
    actions,
    transition,
  }
}
